import React from 'react';
import {Row, Col} from 'antd';
import {hashHistory,} from 'react-router';
import {TableView} from '../../components';
import moment from 'moment';
import qr from "qr-image";
import svgpath from "svgpath";
import './table.css';

class TransportSplitPrint extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            opts: ['送货单打印'],
            key: 0,
            selectedRowKeys: [],
            rows: [],
            resultData: {},
            total: 1,
            searchObj: {
                s: 10,
                p: 1
            },
            value: '',
            num: 0,
            mapRows: [],
            listRows: [],
        };
        this.pageChange = this.pageChange.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
        this.goBack = this.goBack.bind(this);
    };

    goBack() {
        hashHistory.goBack();
    }


    /*翻页*/
    pageChange(page, pageSize) {
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, function () {
            self.initData();
        });
    }


    /*获取列表数据*/
    initData() {
        const data = JSON.parse(window.sessionStorage.getItem('transportSplit'));

        var mapRows = [];
        var result = this.split_array(data.lineList, 10);
        for (var x = 0; x < result.length; x++) {
            result[x].key = x + 1
        }
        for (let j = 0; j < result.length; j++) {
            var totalcount = 0;
            for (let z = 0; z < result[j].length; z++) {
                totalcount = totalcount + result[j][z].splitQuantity;
            }
            mapRows[j] = {
                list: result[j],
                total: result[j].length,
                key: j
            };
            result[j].push({id: 99999999, itemDesc: '合计:', splitQuantity: totalcount});
        }
        var num = Math.ceil(data.lineList.length / 10);
        this.setState({rows: data.lineList, resultData: data, num: num, mapRows: mapRows, listRows: result}, () => {
            const originPath = qr.svgObject(data.orderNumber).path; //  获得二维码的绘制路径
            const scaledPath = svgpath(originPath).scale(3, 3).toString();
            this.setState({
                path: scaledPath
            });
        });
    }

    split_array(arr, len) {
        var a_len = arr.length;
        var result = [];
        for (var i = 0; i < a_len; i += len) {
            result.push(arr.slice(i, i + len));
        }
        return result;
    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.initData();
        //设置离开当前路由时的钩子函数
        // this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    render() {
        const {
            distributor,
            rows,
            total,
            searchObj,
            resultData,
            mapRows,
            printType,
            path
        } = this.state;
        const tableViewProps = {
            loading: false,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '订单编号',
                    dataIndex: 'orderNumber',
                    width: '10%'
                },
                {
                    title: '出库单号',
                    dataIndex: 'deliveryId',
                    width: '10%'
                },
                {
                    title: '物料编码',
                    dataIndex: 'itemNum',
                    width: '10%'
                },
                {
                    title: '物料名称',
                    dataIndex: 'itemDesc',
                    width: '40%'
                },
                {
                    title: '数量',
                    dataIndex: 'splitQuantity',
                    width: '6%'
                },
                {
                    title: '备注',
                    dataIndex: 'remark',
                    width: '10%'
                }
            ],
            paginationHide: true,
            rows
        };
        const h1 = {width: '100%', textAlign: 'center', color: '#000', marginTop: -8}
        const top = {width: '100%', textAlign: 'center', position: 'relative', color: '#000'}
        const printDate = moment(new Date()).format('YYYY/MM/DD');
        const dom = (mapRows || []).map(function (ele, key) {
            return <div style={{padding: '5px', color: '#000'}} key={ele.key}>
                <p style={top}>
                    <span style={{position: 'absolute', left: 0, color: '#000'}}>{printDate}</span>
                </p>
                <h2 style={h1}>浙江天正电气股份有限公司</h2>
                <h2 style={h1}>送货单</h2>
                <div style={{position: "absolute", marginTop: "-20px", right: "20px", zIndex: "99"}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="80px" height="80px">
                        <path
                            d={path}
                        />
                    </svg>
                </div>
                <div className="dms-table-box" style={{lineHeight: '5px', marginTop: -5}}>
                    <Row style={{lineHeight: '18px', marginLeft: 14}}>
                        <Col span={10}>
                            <label>单号：{resultData.orderNumber}</label>
                        </Col>
                        <Col span={10}>
                            <label>客户名称：{resultData.custName}</label>
                        </Col>
                    </Row>
                    <Row style={{lineHeight: '18px', marginLeft: 14}}>
                        <Col span={10}>
                            <label>日期：{moment(resultData.createdDate).format('YYYY-MM-DD')}</label>
                        </Col>
                        <Col span={10}>
                            <label>地址电话：{resultData.address + ' ' + resultData.phone}</label>
                        </Col>
                    </Row>
                    <Row style={{lineHeight: '18px', marginLeft: 14}}>
                        <Col span={20}>
                            <label>备注：{resultData.remark}</label>
                        </Col>
                    </Row>
                    <div style={{display: "block"}}>
                        <div className="dms-table-box yourClass">
                            <TableView {...tableViewProps} rows={ele.list}/>
                        </div>
                    </div>
                </div>
                <div style={printType == '3' ? {display: "none"} : {display: "block"}}>
                    <p><span>操作员：____________</span>&emsp;<span>出库：____________</span>&emsp;
                        <span>客户签名：____________</span>
                    </p>
                </div>
                <div style={{pageBreakAfter: 'always'}}></div>
            </div>

        })
        return (
            <div>
                {dom}
            </div>
        )
    }
}

export default TransportSplitPrint;


// WEBPACK FOOTER //
// ./src/routes/print/transportSplitPrint.js